import 'twin.macro';
import React from 'react';
import { SignIn } from './SignIn';
import { Parrain } from 'containers/Auth/LoginPage/Parrain';
import { MesssageWrapper } from 'components/Layouts/MessageWrapper';
import { useInscriptionParams } from 'containers/Demarrage/useInscriptionParams';
import { OnboardingWrapper } from 'containers/Demarrage';

export default function LoginPage() {
  const { parrainageToken, parrainName } = useInscriptionParams();
  return (
    <OnboardingWrapper
      floating
      withLogoOnLargerScreens
      withSignupLink
      small
      large={!!parrainName && !!parrainageToken}
    >
      <MesssageWrapper>
        {parrainName && parrainageToken && <Parrain parrain={parrainName} />}
        <SignIn />
      </MesssageWrapper>
    </OnboardingWrapper>
  );
}
